import React from 'react';
import { Building2, LucideIcon, Monitor, Shield, Smartphone, Tablet, User, UserCheck } from 'lucide-react';
import { SOURCE_LABEL, SourceKind } from './portalModel';
import type { PortalActivitySourceType } from './portalTypes';

/** Where a punch came from (Web / Mobile app / Kiosk / Admin App / System), as a chip. */

const SOURCE_ICON: Record<SourceKind, LucideIcon> = {
  web: Monitor,
  mobile: Smartphone,
  kiosk: Tablet,
  admin: Shield,
  system: Shield,
};

const SrcChip: React.FC<{ source: SourceKind; short?: boolean }> = ({ source, short }) => {
  const Icon = SOURCE_ICON[source];
  const label = short ? SOURCE_LABEL[source].split(' ')[0] : SOURCE_LABEL[source];
  return <span className={`srcchip ${source}`}><Icon />{label}</span>;
};

export const ACTIVITY_SOURCE_ICON: Record<PortalActivitySourceType, LucideIcon> = {
  web: Monitor,
  mobile: Smartphone,
  kiosk: Tablet,
  employee: User,
  payroll: Building2,
  supervisor: UserCheck,
  system: Shield,
};

/** An activity feed item's source (GET /portal/activity `source`), with the label the API sent. */
export const ActivitySrcChip: React.FC<{ type: PortalActivitySourceType; label: string }> = ({ type, label }) => {
  const Icon = ACTIVITY_SOURCE_ICON[type] ?? Shield;
  return <span className={`srcchip ${type}`}><Icon />{label}</span>;
};

export default SrcChip;
